<app-svg-sprite></app-svg-sprite>
<se-fe-toast></se-fe-toast>
<router-outlet></router-outlet>
<se-fe-confirm></se-fe-confirm>
